import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Auth via Bearer token: impersonation (per-tab) takes priority, then the
// localStorage auth token (needed when the app runs embedded in an iframe,
// where third-party cookies are blocked/partitioned).
api.interceptors.request.use((config) => {
    const imp = typeof window !== "undefined" ? sessionStorage.getItem("imp_token") : null;
    const auth = typeof window !== "undefined" ? localStorage.getItem("auth_token") : null;
    const t = imp || auth;
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

export const formatApiErrorDetail = (detail) => {
    if (detail == null) return "Algo deu errado. Tente novamente.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
};

export default api;
